/** The light/dark switch in the top bar. Props in, event out: the theme store is the container's. */
import { MoonIcon, SunIcon } from 'lucide-react';
import type { Theme } from '../lib/theme.js';
import { Button } from './ui/button.js';

export type ThemeToggleProps = { readonly theme: Theme; readonly onToggle: () => void };

export function ThemeToggle({ theme, onToggle }: ThemeToggleProps) {
  const next = theme === 'dark' ? 'light' : 'dark';
  return (
    <Button variant="ghost" size="icon" onClick={onToggle} aria-label={`Switch to ${next} mode`} data-testid="theme-toggle" data-theme={theme}>
      {theme === 'dark' ? <SunIcon /> : <MoonIcon />}
    </Button>
  );
}
